<div [class]="class" [formGroup]="form">
  <mat-form-field class="bg-white">
    <mat-label>{{label}}</mat-label>
    <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate" [formControlName]="name" [placeholder]="placeholder" (dateChange)="onChange($event)">
    <mat-icon *ngIf="icon" matPrefix class="text-700 material-symbols-outlined">{{icon}}</mat-icon>
    <div #refSuffix matSuffix>
      <ng-content select="[suffix]"></ng-content>
    </div>
    <mat-datepicker-toggle matIconSuffix [for]="picker">
      <mat-icon matDatepickerToggleIcon class="text-700 material-symbols-outlined">event</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker touchUi #picker></mat-datepicker>
  </mat-form-field>
  <mat-error *ngIf="hasError()" class="text-xs">{{error()}}</mat-error>
  <mat-hint *ngIf="hint" class="text-xs text-600">{{hint}}</mat-hint>
</div>
